export default __webpack_public_path__ + "static/media/kartikeya.b9d32a19.jpeg";